import { ReactNode, ReactElement, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Container } from '@mui/material';

import { HtmlTitle } from '@ocx-app/components/router/HtmlTitle';
import { VendorLogo } from '@ocx-app/components/Layout/NavigationBar/VendorLogo/VendorLogo';
import { BackButton } from '@ocx-app/components/Layout/NavigationBar/BackButton/BackButton';
import { intl } from '@ocx-app/lib/translation/TranslationProvider';

import { Typography, PoweredByWatermark, NavigationBar, Page, PageContent } from '@ocx/ui';

import { messages } from './signup.messages';

export type RequestLinkLayoutProps = {
  titleEnabled?: boolean;
  backButtonEnabled?: boolean;
  children: ReactNode;
};

export const SignupLayout = (props: RequestLinkLayoutProps) => {
  const { children, titleEnabled, backButtonEnabled } = props;

  const headerCenter = useMemo<ReactElement>(() => {
    if (!titleEnabled) {
      return <VendorLogo />;
    }
    return (
      <Typography component="h2">
        <FormattedMessage {...messages['signup:account-verification-title']} />
      </Typography>
    );
  }, [titleEnabled]);

  return (
    <Page>
      <HtmlTitle title={intl.formatMessage(messages['signup:html-title'])} />
      <NavigationBar left={backButtonEnabled ? <BackButton /> : undefined} center={headerCenter} />
      <PageContent bgcolor="background.paper">
        <Container maxWidth="sm" disableGutters sx={{ display: 'flex', flexDirection: 'column', flex: 1, px: 0 }}>
          {children}
        </Container>
        <PoweredByWatermark />
      </PageContent>
    </Page>
  );
};
